import React, { useEffect, useState } from "react";
import styles from "./PasienHome.module.css";
import Navbar from "../../layouts/Home/Navbar";
import Footer from "../../layouts/Home/Footer";
import Button from "../../components/Button";
import { useModal } from "../../../context/ModalProvider";
import { useHome } from "../../../context/HomeProvider";
import { useAuth } from "../../../context/AuthProvider";
import ModalService from "../../components/ModalService";
import ModalClinic from "../../components/ModalClinic";
import { useHistory } from "react-router-dom";

export default function PasienHome() {
  const modal = useModal();
  const history = useHistory();
  const {
    dataBusinessClinic,
    dataServices,
    dataClinic,
    selectedService,
    setSelectedClinic,
    setSelectedService,
  } = useHome();
  const { isAuthenticated } = useAuth();

  const [isShowClinic, setIsShowClinic] = useState(false);

  useEffect(() => {
    if (window.location.pathname.split("/").includes("dashboard")) {
      window.history.pushState({}, "", "/pasien");
    }
  }, []);

  useEffect(() => {
    if (
      isShowClinic &&
      (selectedService || selectedService === 0) &&
      dataClinic.length > 0
    ) {
      modal.show(
        () => (
          <ModalClinic
            data={dataClinic}
            handleSelect={(idClinic) => handleCheckReservation(idClinic)}
            setIsShowClinic={setIsShowClinic}
          />
        ),
        {
          title: "Pilih Klinik",
          isBorderTitle: true,
          size: "lg",
        }
      );
    }

    // eslint-disable-next-line
  }, [selectedService, dataClinic, isShowClinic]);

  const dataLink = [
    { label: "Untuk Klinik", url: "/", isLink: true },
    { label: "Untuk Pasien", url: "", isActive: true },
    { label: "Lokasi Klinik", url: "/" },
  ];

  const handleCheckReservation = (id) => {
    modal.dismiss();
    setIsShowClinic(!isShowClinic);
    setSelectedClinic(id);
    history.push(
      `/reservation-pasien?serviceId=${selectedService}&clinicId=${id}`
    );
  };

  return (
    <div style={{ background: "white" }}>
      <Navbar dataLink={dataLink} />
      <div className={styles.heroWrapper}>
        <div className={styles.wrapperDescHero}>
          <p className={styles.titleHero}>
            Pelayanan Kesehatan Terbaik dari Klinik
          </p>
          <p className={styles.descHero}>
            Untuk Anda dan Keluarga, di mana saja.
          </p>
          {!isAuthenticated && (
            <Button
              className={styles.buttonHero}
              onClick={() =>
                modal.show(
                  () => (
                    <ModalService
                      data={dataServices}
                      handleSelect={(id) => {
                        setIsShowClinic(!isShowClinic);
                        setSelectedService(id);
                      }}
                    />
                  ),
                  {
                    title: "Pilih Layanan",
                    isBorderTitle: true,
                  }
                )
              }
            >
              Pesan Sekarang
            </Button>
          )}
        </div>
        <img
          src="/assets/svg/hero-image-pasien.svg"
          alt=""
          className="img-fluid"
        />
      </div>

      <div className={styles.keunggulanWrapper}>
        <p className={styles.titleSection}>Keunggulan Kami</p>
        <div className={styles.keunggulanItemWrapper}>
          {[1, 2, 3].map((_, index) => (
            <div className={styles.keunggulanItem} key={index}>
              <div className={styles.iconItemWrapper}>
                <i className="fas fa-briefcase-medical"></i>
              </div>
              <p className={styles.keunggulanItemText}>
                Layanan kesehatan berkualitas sesuai kebutuhan
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.serviceWrapper}>
        <p className={styles.titleSection}>Layanan Kami</p>
        <div className={styles.serviceItemWrapper}>
          {dataServices?.map((item, index) => (
            <div className={styles.serviceItem} key={index}>
              <div className={styles.serviceWrapperDesc}>
                <p className={styles.serviceItemTitle}>{item.name}</p>
                <p className={styles.serviceItemDesc}>
                  Dapatkan kulit yang sehat serta bercahaya di Klinik Spesialis
                  Kulit dan Dokter Kecantikan Sistem Klinik.
                </p>
              </div>
              <img src="/assets/svg/service-1.svg" alt="" />
            </div>
          ))}
          {dataServices?.length < 2 && (
            <div className={styles.serviceItem}>
              <div className={styles.serviceWrapperDesc}>
                <p className={styles.serviceItemTitle}>Coming Soon</p>
              </div>
              <img src="/assets/svg/service-comingsoon.svg" alt="" />
            </div>
          )}
        </div>
      </div>

      <div className={styles.clinicWrapper}>
        <div className="d-flex justify-content-between align-items-center w-100 mb-3">
          <p className={styles.titleSection}>Klinik Kami</p>
        </div>

        {dataBusinessClinic && dataBusinessClinic.length > 0 ? (
          <div
            className={`${styles.newClinicWrapperList} ${
              dataBusinessClinic.length === 1 ? styles.singleClinic : ""
            }`}
          >
            {dataBusinessClinic.slice(0, 6)?.map((clinic, index) => (
              <div
                className={styles.newClinicItem}
                key={clinic.id}
                onClick={() =>
                  history.push(`/klinik-kecantikan/${clinic.slug}`)
                }
              >
                <div className={styles.newClinicImageWrapper}>
                  <img
                    src={
                      clinic?.image_url ||
                      "https://dummyimage.com/400x400/e9ecef/6c757d?text=Klinik"
                    }
                    alt={clinic.name}
                    className={styles.newClinicImage}
                    onError={(e) => {
                      e.target.src =
                        "https://dummyimage.com/400x400/e9ecef/6c757d?text=Klinik";
                    }}
                  />
                  <div className={styles.newClinicBadge}>
                    {clinic.published ? (
                      <span className={styles.badgePublished}>
                        <i className="fas fa-check-circle"></i> Aktif
                      </span>
                    ) : (
                      <span className={styles.badgeDraft}>
                        <i className="fas fa-clock"></i> Coming Soon
                      </span>
                    )}
                  </div>
                </div>

                <div className={styles.newClinicItemInfo}>
                  <h3 className={styles.newClinicInfoTitle}>
                    {clinic.business_name}
                  </h3>

                  <div className={styles.newClinicDetails}>
                    <div className={styles.newInfoItem}>
                      <i className="fas fa-map-marker-alt text-primary"></i>
                      <p className={styles.newInfoText}>
                        {clinic.address?.address
                          ? clinic.address.address.length > 80
                            ? `${clinic.address.address.substring(0, 80)}...`
                            : clinic.address.address
                          : "Alamat tidak tersedia"}
                      </p>
                    </div>

                    {clinic.phone_number && (
                      <div className={styles.newInfoItem}>
                        <i className="fas fa-phone text-success"></i>
                        <p className={styles.newInfoText}>
                          {clinic.phone_number}
                        </p>
                      </div>
                    )}
                  </div>

                  <div className={styles.newClinicDescription}>
                    <p className={styles.newAboutText}>
                      {clinic.about
                        ? clinic.about.length > 100
                          ? `${clinic.about.substring(0, 100)}...`
                          : clinic.about
                        : "Klinik terpercaya dengan layanan kesehatan berkualitas."}
                    </p>
                  </div>

                  <div className={styles.newClinicActions}>
                    <Button
                      variant="primary"
                      leftIcon={<i className="fas fa-eye"></i>}
                      label="Lihat Detail"
                      onClick={(e) => {
                        e.stopPropagation();
                        history.push(`/klinik-kecantikan/${clinic.slug}`);
                      }}
                      className={styles.actionButton}
                    />

                    <Button
                      variant="outline-primary"
                      leftIcon={<i className="far fa-calendar-alt"></i>}
                      label="Buat Janji"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedService(3);
                        setSelectedClinic(clinic.id);

                        setTimeout(() => {
                          history.push(
                            `/reservation-pasien?serviceId=${3}&clinicId=${
                              clinic.id
                            }`
                          );
                        }, 100);
                      }}
                      className={styles.actionButton}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyIcon}>
              <i className="fas fa-hospital"></i>
            </div>
            <h4 className={styles.emptyTitle}>Belum Ada Klinik</h4>
            <p className={styles.emptyDescription}>
              Klinik sedang dalam proses persiapan. Silakan cek kembali nanti.
            </p>
          </div>
        )}
      </div>

      <Footer dataLink={dataLink} />
    </div>
  );
}
